import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react'
import React from 'react'

const EventRegister: React.FC = () => {
    useIonViewDidEnter(() => {
        const a = document.createElement('a')
        a.href = 'https://forms.gle/esuhRzjXDPx9WLXQ8'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    })
    return (
        <IonPage>
            <IonContent></IonContent>
        </IonPage>
    )
}

export default EventRegister